@use "../../../../../globals/bcp-2022/objects/flyouts";

.impersonate__customer-list {
  list-style: none;
  padding: 0;

  &__item:not(:last-child) {
    display: block;
    padding-bottom: 0.5rem;
    margin-bottom: 0.5rem;

    @include flyouts.separator("bottom");
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
